var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00016 8.33333L3.3335 10L8.3335 15L16.6668 6.66667L15.0002 5L8.3335 11.6667L5.00016 8.33333Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.14a30e7af2aeebffb2540cb047723d39.svg";
export { ForwardRef as ReactComponent };